<template>
  <div style="display: flex; gap: 0.5rem">
    <v-icon dense>mdi-map-marker-outline</v-icon>
    <v-text-field
      v-model="departingFrom"
      label="Departing From"
      outlined
      hide-details
      :disabled="loading || disabled"
      @blur="editDepartingFrom"
      @keypress.enter="editDepartingFrom"
      dense
    ></v-text-field>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "TripDepartingFrom",
  props: {
    trip: Object,
    message: Function,
    errorMessage: Function,
    getTrips: Function,
    disabled: Boolean,
  },
  data: () => ({
    departingFrom: "",
    loading: false,
  }),
  methods: {
    editDepartingFrom() {
      if (this.disabled) return;
      if (this.departingFrom === (this.trip?.departingFrom ?? "")) return;
      this.loading = true;
      const data = {
        tripId: this.trip.id,
        departingFrom: this.departingFrom.trim(),
      };
      axios({
        url: `${process.env.VUE_APP_BASE_URL ?? ""}/api/edittripdepartingfrom`,
        method: "POST",
        headers: { Authorization: localStorage.getItem("Authorization") },
        data: JSON.stringify(data),
      })
        .then(() => {
          this.getTrips();
        })
        .catch((error) => {
          if (error.response) {
            this.errorMessage(error.response.data.error);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    if (this.trip?.departingFrom) {
      this.departingFrom = this.trip.departingFrom;
    }
  },
};
</script>
